// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bf5d2dcd","178":"a12c7d19","223":"5354df0d","453":"ed3810f9","613":"c606aa7b","977":"819f3233"}[chunkId] + ".chunk.js";
};